import $ from 'jquery';

$($ => {
    $('.menu-toggle').on('click touchstart touchend', function () {
        $('body').toggleClass('menu-open');
        $('.site-header').toggleClass('menu-open');
    });

    $('body').on('click touchstart touchend', '.disabled', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

    $('input[type=checkbox]').on('change', function () {
        $(this).parent().toggleClass('checked');
    });

    var inputs = $('input[type=text], input[type=email], input[type=tel], textarea');
    inputs.each(function () {
        var parent = $(this).closest('.gfield');
        var thisValue = $(this).val();
        if (thisValue) {
            $(parent).addClass('focus');
        }
    });

    inputs.on('focus', function () {
        var parent = $(this).closest('.gfield');
        $(parent).addClass('focus');
    });

    inputs.on('blur', function () {
        var parent = $(this).closest('.gfield');
        var thisValue = $(this).val();
        if (thisValue) {
            return;
        }

        parent.removeClass('focus');
    });

    let intialPageLoad = true;
    let article_list_loaded_counter = 0;
    htmx.on("htmx:afterSettle", function (evt) {
        let padding = 64;
        if (intialPageLoad) {
            intialPageLoad = false;
            return;
        }

        setTimeout(() => {
            // Is request ajax?
            if (evt.detail.requestConfig.headers['HX-Request'] !== 'true') {
                return;
            }

            if (article_list_loaded_counter <= 0) {
                article_list_loaded_counter++;
                return;
            }

            // Check if the event is related to the article list loading
            if (evt.detail && (evt.detail.requestConfig.path.includes('articlelist') || evt.detail.requestConfig.path.includes('productlist'))) {
                // Only update the URL if the page number exists
                let scroll_to = '';

                if (evt.detail.requestConfig.path.includes('articlelist')) {
                    scroll_to = $('.article-archive-list--wrapper').offset().top;
                }

                if (evt.detail.requestConfig.path.includes('productlist')) {
                    scroll_to = $('.product-archive--products').offset().top;
                }

                if (!scroll_to) {
                    return;
                }

                $('html, body').animate({
                    scrollTop: (scroll_to - padding)
                }, 500);

                article_list_loaded_counter++;
            }
        }, 500);
    });

    $('body').on('click', '.filters--clear', function (e) {
        e.preventDefault();
        if ($('.product-filters--inner').length) {
            $('.product-filters--inner').find('input[type=checkbox]').prop('checked', false);
            // Reset the hx-get attribute to default
            const element = $('.product-archive--products');
            const default_url = element.attr('data-url');
            element.attr('hx-get', default_url);
            htmx.process('.product-archive--products');
        } else if ($('.article-filters').length) {
            $('.filter-options--wrapper').find('input[type=checkbox]').prop('checked', false);
            // Reset the hx-get attribute to default
            const element = $('.article-archive-list--inner');
            const default_url = element.attr('data-url');
            element.attr('hx-get', default_url);
            htmx.process('.article-archive-list--inner');
        }
    });

    $('body').on('click', '.filters--close', function (e) {
        console.log('close');
        e.preventDefault();
        $('body').removeClass('menu-open');
        $('.product-filters').removeClass('open');
        $('.article-filters').find('.open').removeClass('open');
    });

    // Cloudflare Stream player
    $('.cf-player').each(function () {
        const video = $(this).get(0);
        const videoId = $(this).attr('data-video-id');
        let url = `https://customer-bjksjre8pumne51s.cloudflarestream.com/${videoId}/manifest/video.m3u8`;


        if (Hls.isSupported()) {
            const hls = new Hls();

            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                hls.loadSource(
                    url
                );
            });
            video.play();
        } else {
            console.log('HLS not supported');
            video.src = url;
        }
    });

    if ($('#gform_wrapper_4').length) {
        //do ajax query to check for pre-populated fields
        $.ajax({
            url: agd_ajax.ajaxurl,
            type: 'POST',
            data: {
                action: 'get_prepopulated_fields',
                form_id: 4
            },
            dataType: 'JSON',
            success: function (data) {
                if (data) {
                    $.each(data, function (key, value) {
                        $('#input_' + key).val(value);
                    });
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
    }
});
